import { render } from "./OnePage.vue?vue&type=template&id=2487b9ba"
import script from "./OnePage.vue?vue&type=script&lang=js"
export * from "./OnePage.vue?vue&type=script&lang=js"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__